import React, { useState, useContext, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'
import { Input } from 'reactstrap'
import ProfileMenu from '../CommonForBoth/TopbarDropdown/ProfileMenu'
import LogoSmall from '../../assets/images/logo-vendora-symbol.svg'
import LogoLarge from '../../assets/images/logo-vendora-full.svg'
import ApiService from '../../data/services/ApiService'

import Cart from '../CommonForBoth/Cart'
import { GeneralContext } from '../../context/'

const Header = (props) => {
    const searcherRef = useRef(null)

    const generalContext = useContext(GeneralContext)
    const { setLoading, setCartItemsCount, setPagination } = generalContext

    const [toggleSearch, setToggleSearch] = useState(false)
    const toggleSearcher = () => setToggleSearch(prevState => !prevState)

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true)
        return () => {
            document.removeEventListener("click", handleClickOutside, true)
        }
    })

    const handleClickOutside = event => {
        if (searcherRef.current && !searcherRef.current.contains(event.target)) {
            setToggleSearch(false)
        }
    }

    useEffect(() => {
        document.getElementById('searcher').focus()
    }, [toggleSearch]) // eslint-disable-line

    useEffect(() => {
        (async function fetchData() {
            await fetchCartItemsCount()
        })()

        async function fetchCartItemsCount() {
            setLoading(true)
            const response = await ApiService.getCartCountItems()
            setCartItemsCount(response.data.itemsOnCart)
            setLoading(false)
        }
    }, []) // eslint-disable-line

    /**
     * Toggle sidebar
     */
    const toggleMenu = () => {
        props.toggleMenuCallback()
    }

    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
            /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen()
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen()
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                )
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        }
    }

    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                        <div className="navbar-brand-box">
                            <Link to="/" className="logo">
                                <span>
                                    <span className="logo-sm">
                                        <img src={LogoSmall}
                                            alt="Vendora | Más que un negocio, un movimiento"
                                            height={32} />
                                    </span>

                                    <span className="logo-lg">
                                        <img src={LogoLarge}
                                            alt="Vendora | Más que un negocio, un movimiento"
                                            height={34} />
                                    </span>
                                </span>
                            </Link>
                        </div>

                        <button
                            type="button"
                            onClick={toggleMenu}
                            className="btn btn-sm px-3 font-size-16 header-item waves-effect"
                            id="vertical-menu-btn">
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                    </div>
                    <div className="d-flex">
                        <div className="dropdown d-none d-lg-inline-block ml-1">
                            <button
                                type="button"
                                onClick={toggleFullscreen}
                                className="btn header-item noti-icon waves-effect"
                                data-toggle="fullscreen"
                            >
                                <i className="bx bx-fullscreen"></i>
                            </button>
                        </div>
                        <Cart />

                        <div className="dropdown d-inline-block ml-2" ref={searcherRef}>
                            <button
                                onClick={() => {
                                    toggleSearcher()
                                    window.analytics.track("Opened search bar")
                                }}
                                type="button"
                                className="btn header-item noti-icon waves-effect"
                                id="page-header-search-dropdown"
                            >
                                <i className="mdi mdi-magnify"></i>
                            </button>
                            <div
                                className={toggleSearch ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show" : "dropdown-menu"}
                                aria-labelledby="page-header-search-dropdown"
                            >
                                <div className="p-3">
                                    <Input
                                        type="text"
                                        id="searcher"
                                        name="searcher"
                                        className="form-control"
                                        required
                                        placeholder="Buscar productos..."
                                        onKeyUp={event => {
                                            if (event.key === 'Enter' || event.keyCode === 13) {
                                                window.analytics.track("Term searched", { filter: event.target.value })
                                                setPagination([])
                                                props.history.push(`/discovery?search=${event.target.value.toUpperCase()}`)
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <ProfileMenu />
                    </div>
                </div>
            </header>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    const { layoutType } = state.Layout
    return { layoutType }
}

export default connect(mapStatetoProps, {})(
    withNamespaces()(withRouter(Header))
)
